import styled from 'styled-components/macro';
import { Title4 } from 'components/text';
import { media } from 'style/media';

export const ArrowLinkTitle = styled(Title4)`
    font-size: 0.8rem;
    ${media.mediumtablet`
        font-size: 0.9rem;
    `};
`;